// extracted by mini-css-extract-plugin
export default {"paper":"jIjweBTsuR5bcFjcLER5","list":"gyj4nsUupxjS1RV39FwW"};